import { TeamModel } from "./Team";

export class FieldingStatisticsModel {
    public type = '';
    public year = '';
    public a = '';
    public po = '';
    public e = '';
    public tc = '';
    public f = '';
    public rfg = '';
    public rfi = '';
    public i = '';
    public g = '';
    public cs = '';
    public pb = '';
    public gs = '';
    public h2p = '';
    public h3p = '';
    public sb = '';
    public era = '';
    public cif = '';
    public wp = '';
    public te = '';
    public sbp = '';
    public p = '';
    public pk = '';
    public opponent: TeamModel = new TeamModel();
    public isHome = false;
    public date: Date = new Date();
    public get opp(): string {
        return (this.isHome ? '' : '@') + this.opponent.abbrU;
    }

    constructor(obj?: any) {
        if (obj) {
            this.a = typeof obj.a !== 'undefined' ? obj.a : '';
            this.po = typeof obj.po !== 'undefined' ? obj.po : '';
            this.e = typeof obj.e !== 'undefined' ? obj.e : '';
            this.tc = typeof obj.tc !== 'undefined' ? obj.tc : '';
            this.f = typeof obj.f !== 'undefined' ? obj.f : '';
            this.rfg = typeof obj.rfg !== 'undefined' ? obj.rfg : '';
            this.rfi = typeof obj.rfi !== 'undefined' ? obj.rfi : '';
            this.i = typeof obj.i !== 'undefined' ? obj.i : '';
            this.g = typeof obj.g !== 'undefined' ? obj.g : '';
            this.cs = typeof obj.cs !== 'undefined' ? obj.cs : '';
            this.pb = typeof obj.pb !== 'undefined' ? obj.pb : '';
            this.gs = typeof obj.gs !== 'undefined' ? obj.gs : '';
            this.h2p = typeof obj.h2p !== 'undefined' ? obj.h2p : '';
            this.h3p = typeof obj.h3p !== 'undefined' ? obj.h3p : '';
            this.sb = typeof obj.sb !== 'undefined' ? obj.sb : '';
            this.era = typeof obj.era !== 'undefined' ? obj.era : '';
            this.cif = typeof obj.cif !== 'undefined' ? obj.cif : '';
            this.wp = typeof obj.wp !== 'undefined' ? obj.wp : '';
            this.te = typeof obj.te !== 'undefined' ? obj.te : '';
            this.sbp = typeof obj.sbp !== 'undefined' ? obj.sbp : '';
            this.p = typeof obj.p !== 'undefined' ? obj.p : '';
            this.pk = typeof obj.pk !== 'undefined' ? obj.pk : '';
        }
    }

}